import { render, staticRenderFns } from "./TranProgramActivityReminderListFilter.vue?vue&type=template&id=81a67916&scoped=true"
import script from "./TranProgramActivityReminderListFilter.vue?vue&type=script&lang=js"
export * from "./TranProgramActivityReminderListFilter.vue?vue&type=script&lang=js"
import style0 from "./TranProgramActivityReminderListFilter.vue?vue&type=style&index=0&id=81a67916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a67916",
  null
  
)

export default component.exports